import React from 'react';
import Icon from './Icon';

/**
 * Cockpit Checkbox — square 16px, rust when checked, check springs in.
 */
export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export default function Checkbox({ checked = false, onChange, label, disabled = false, style }: CheckboxProps) {
  return (
    <label
      className="ck-checkbox pressable"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '9px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        userSelect: 'none',
        ...style,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.checked)}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
      />
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '16px',
          height: '16px',
          borderRadius: '5px',
          background: checked ? 'var(--accent)' : 'var(--surface-input)',
          border: checked ? '1px solid transparent' : '1px solid var(--border-strong)',
          color: 'var(--text-on-accent)',
          transition: 'background var(--dur-fast) var(--ease-out), border-color var(--dur-fast) var(--ease-out)',
          flexShrink: 0,
        }}
      >
        <Icon
          name="check"
          size={11}
          strokeWidth={3}
          style={{
            opacity: checked ? 1 : 0,
            transform: checked ? 'scale(1)' : 'scale(0.5)',
            transition: 'opacity var(--dur-fast) var(--ease-out), transform var(--dur-base) var(--ease-spring)',
          }}
        />
      </span>
      {label ? <span style={{ fontSize: 'var(--text-base)', color: 'var(--text-body)' }}>{label}</span> : null}
    </label>
  );
}
